import { getApiConfig } from '@src/config/api';

const RESUME_SAMPLE_PATH = '/resume_example.pdf';

/**
 * ルート相対パスを絶対URLに変換
 */
function toAbsoluteUrl(path: string): string {
  if (typeof window !== 'undefined' && window.location) {
    const normalizedPath = path.startsWith('/') ? path : `/${path}`;
    return `${window.location.origin}${normalizedPath}`;
  }
  return path;
}

/**
 * 職務経歴書PDFダウンロードURLを取得
 */
export function getResumePdfDownloadUrl(token?: string): string {
  const apiConfig = getApiConfig();

  if (apiConfig.isMockMode) {
    return toAbsoluteUrl(RESUME_SAMPLE_PATH);
  }

  if (!token) {
    return '';
  }

  const baseUrl = apiConfig.baseUrl.replace(/\/$/, '');
  return `${baseUrl}/api/v1/pdf/resume/${token}`;
}
